<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="CN" id="_idParaDest-1"> <img alt="" class="_idGenObjectAttribute-1" src="image/EuphoriaTitle.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook4276.vue?88ff02ce